import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  enteredMobile: null,
  enteredEmail:null,
  loginChildPage:null,
  signupEnteredMobile:null,
  signupEnteredOtherDetails:{},
  enteredLoginMobileOtp:null,
  enteredLoginEmailItp:null,
  enteredSignupMobileOtp:null,
  isPopupAccepted:false
};

export const loginCredSlice = createSlice({
  name: "loginCred",
  initialState,
  reducers: {
    setMobileNo: (state, action) => {
      state.enteredMobile = action.payload;
    },
    setEmail: (state, action) => {
        state.enteredEmail = action.payload;
    },
    setLoginChildPageName: (state, action)=>{
        state.loginChildPage =action.payload

        if(action.payload == null){
          // console.log("null login called");
          state.enteredMobile= null
          state.enteredEmail=null
          state.loginChildPage=null
          state.signupEnteredMobile=null
          state.signupEnteredOtherDetails={}
          state.enteredLoginMobileOtp=null
          state.enteredLoginEmailItp=null
          state.enteredSignupMobileOtp=null
        }
    },
    setSignupEnteredMobile: (state, action)=>{
      state.signupEnteredMobile =action.payload
  },
  setSignupEnteredOtherDetails: (state, action)=>{
    state.signupEnteredOtherDetails =action.payload
  },
  setEnteredLoginMobileOtp: (state,action)=>{
    state.enteredLoginMobileOtp = action.payload
  },
  setEnteredLoginEmailOtp: (state,action)=>{
    state.enteredLoginEmailItp = action.payload
  },
  setEnteredSignUpMobileOtp:(state,action)=>{
    state.enteredSignupMobileOtp = action.payload
  },
  setAcceptPopupStatus:(state,action)=>{
    state.isPopupAccepted = action.payload
  }
  },
});

export const { setMobileNo, setEmail,setLoginChildPageName,setSignupEnteredMobile,setSignupEnteredOtherDetails,setEnteredLoginMobileOtp,setEnteredLoginEmailOtp,setEnteredSignUpMobileOtp,setAcceptPopupStatus  } = loginCredSlice.actions;

export default loginCredSlice.reducer;
